<template>
    <div class="inner_flag" v-html="flag"></div>
</template>

<script>
export default {
    name: 'svg-flag',
    props: {
        flag: {
            type: String,
            default: null
        },
        growByHeight: {
            type: Boolean,
            default: true
        },
    },
    mounted() {
        if (this.$el.firstElementChild.nodeName === 'svg') {
            const svgElement = this.$el.firstElementChild;
            const viewBox = svgElement.getAttribute('viewBox').split(' ').map(n => Number(n));
            const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2);
            if (this.growByHeight) {
                svgElement.setAttribute('height', '1em');
                svgElement.setAttribute('width', `${widthToHeight}em`);
            } else {
                svgElement.setAttribute('width', '1em');
                svgElement.setAttribute('height', `${1 / widthToHeight}em`);
            }
            svgElement.classList.add('svg-class');
        }
    }
}
</script>

<style lang="scss" scoped>
  .inner_flag {
    font-size: 42px;
    background-color: #FFFFFF;
    height: 3em;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .svg-class {
    margin: 0
  }
</style>
